import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  dialogContentRoot: {
    padding: 0,
    display: "flex",
    justifyContent: "center",
  },
  btnAction: {
    boxSizing: "content-box",
    color: "white",
    "&:hover": {
      fontWeight: "bold",
    },
  },
  calendarWapper: {
    position: "relative",

    "& .DayPickerNavigation_button__default": {
      border: "none",
    },

    "& .CalendarDay__default": {
      border: "none",
    },

    "& .CalendarDay__selected_span": {
      background: theme.palette.secondary.light,
      color: theme.palette.text.primary,
      border: "none",
      borderRadius: 0,
    },

    // Will edit selected date or the endpoints of a range of dates
    "& .CalendarDay__selected": {
      background: theme.palette.secondary.main,
      color: "white",
    },

    "& .CalendarDay__selected_start": {
      borderBottomRightRadius: 0,
      borderTopRightRadius: 0,
    },

    "& .CalendarDay__selected_end": {
      borderBottomLeftRadius: 0,
      borderTopLeftRadius: 0,
    },

    // Will edit when hovered over. _span style also has this property
    "& .CalendarDay__selected:hover": {
      background: "#e4e7e7",
      borderColor: theme.palette.primary.main,
      color: theme.palette.text.primary,
    },

    // Will edit when the second date (end date) in a range of dates
    // is not yet selected. Edits the dates between your mouse and said date
    "& .CalendarDay__selected_span:hover": {
      background: "#e4e7e7",
    },
  },
  calendarFooter: {
    display: "flex",
    justifyContent: "flex-end",
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(13),
    alignItems: "center",
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(2),
    "& :last-child": {
      marginRight: 0,
    },
  },
  footerItem: {
    display: "inline-block",
    marginRight: theme.spacing(1),
  },
}));

export default useStyles;
